<template>
  <div class="page">
    <h2 class="accent--text">
      <v-icon color="primary" class="ml-3" large>mdi-web</v-icon>
      بيانات التواصل
      <back-button />
    </h2>
    <hr class="mt-5 mb-8 header-divider" />

    <v-card>
      <!-- CONTENT -->
      <v-card-text class="pt-5 pb-0">
        <v-container>
          <v-progress-linear
            v-if="loading"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>

          <div v-else>
            <!-- facebook -->
            <v-text-field
              dense
              outlined
              label="فيس بوك"
              v-model="settings.social_facebook"
            ></v-text-field>
            <!-- twitter -->
            <v-text-field
              dense
              outlined
              label="تويتر"
              v-model="settings.social_twitter"
            ></v-text-field>
            <!-- telegram -->
            <v-text-field
              dense
              outlined
              label="تيليجرام"
              v-model="settings.social_telegram"
            ></v-text-field>
            <!-- soundcloud -->
            <v-text-field
              dense
              outlined
              label="ساوند كلاود"
              v-model="settings.social_soundcloud"
            ></v-text-field>
            <!-- youtube -->
            <v-text-field
              dense
              outlined
              label="يوتيوب"
              v-model="settings.social_youtube"
            ></v-text-field>
            <!-- periscope -->
            <v-text-field
              dense
              outlined
              label="بيرسكوب"
              v-model="settings.social_periscope"
            ></v-text-field>

            <hr class="mb-5 light-divider" />

            <editor
              :value="settings.location_address"
              @input="settings.location_address = $event"
            />

            <v-row>
              <v-col :cols="12" :md="6">
                <v-text-field
                  dense
                  outlined
                  label="latitude"
                  v-model="settings.location_latitude"
                ></v-text-field>
              </v-col>
              <v-col :cols="12" :md="6">
                <v-text-field
                  dense
                  outlined
                  label="longitude"
                  v-model="settings.location_longitude"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>

    <!-- ACTIONS -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" elevation="1" dark @click="update(settings)">حفظ</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Editor from '@/components/Inputs/Editor';

export default {
  name: 'social-links',
  components: { Editor },


  data: function () {
    return {
      settings: {},
      loading: false
    }
  },


  created() {
    this.fetchContent();
  },


  methods: {
    fetchContent() {
      this.loading = true;

      this.axios.get('/admin/content/contact-info')
        .then((response) => {
          this.settings = response.data;
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر جلب الروابط',
            color: 'accent'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    update(settings) {
      this.loading = true;

      this.axios.post('/admin/content/contact-info', settings)
        .then(() => {
          this.$bus.$emit('showSnackbar', {
            text: 'تم تعديل روابط مواقع التواصل بنجاح',
            color: 'success'
          });
        })
        .catch((error) => {
          this.$bus.$emit('showSnackbar', {
            text: 'تعذر تعديل الروابط',
            color: 'accent'
          });
        })
        .finally(() => {
          setTimeout(() => { this.loading = false; }, 1000);
        });
    }
  }
}
</script>
